import { env } from '@/services/EnvironmentVariables'
import { cn } from '@/utlis/cn'

export default function OSXTitleBar(props: { noBg?: boolean; className?: string }) {
    if (!env.IS_ELECTRON || env.OS !== 'darwin') {
        return null
    }

    return (
        <div
            className={cn(
                'w-full h-[30px] app-window-drag-region',
                !props.noBg && false && 'border-b border-b-white/3 bg-[rgba(255,255,255,0.00)] z-40',
                props.className
            )}
        ></div>
    )
}
